import { useTheme } from '@mui/material';
import Box from '@mui/material/Box';

import { SegmentTypes } from './hooks/useGetCycleSegments';

type PauseSegmentProps = {
  startPosition: string;
  endPosition: string;
  type?: string;
  hasLogging?: boolean;
  isOpen?: boolean;
};

const topByType = (hasLogging: boolean): Record<string, string> => ({
  [SegmentTypes.PICK_UP]: '0%',
  [SegmentTypes.EN_ROUTE]: hasLogging ? '25%' : '33%',
  [SegmentTypes.DROP_OFF]: hasLogging ? '50%' : '66%',
  [SegmentTypes.LOGGING]: '75%',
});

// zIndex 2: above cycle segments (no explicit z-index) but below TimeIndicator (zIndex 3)
const PauseSegment = ({
  startPosition,
  endPosition,
  type,
  hasLogging = false,
  isOpen = false,
}: PauseSegmentProps) => {
  const theme = useTheme();
  const top = type ? topByType(hasLogging)[type] : '0%';

  if (!top) return null;

  if (isOpen) {
    return (
      <Box
        sx={{
          position: 'absolute',
          right: 0,
          top,
          width: '16px',
          height: '16px',
          borderRadius: '2px 0 0 2px',
          backgroundColor: theme.brandV2.colors.treadGray5,
          transform: 'translateY(25%)',
          zIndex: 2,
          pointerEvents: 'none',
        }}
      />
    );
  }

  return (
    <Box
      sx={{
        position: 'absolute',
        left: startPosition,
        right: endPosition,
        top,
        height: '16px',
        borderRadius: '2px',
        backgroundColor: theme.brandV2.colors.treadGray5,
        transform: 'translateY(25%)',
        zIndex: 2,
        pointerEvents: 'none',
      }}
    />
  );
};

export { PauseSegment };
